
import React from 'react'

const UserRow = (props) => {
  return props.user ? <li onClick={props.onClick || null} className="row" >
    <div className="link">
      <img className="avatar" src={props.user.picture} alt="Profile" />
    </div>
    <div className="md-subhead row-content" >
      {props.user.name === '' || !props.user.name ?props.user.email : props.user.name}<br />
      <div className="md-body-2">
        {props.children}
      </div>
    </div>
  </li> : null
}

export default UserRow;



// WEBPACK FOOTER //
// ./src/components/user/UserRow.jsx